import axios from 'axios';
import { refreshAccessToken } from '../features/Login/services';

const kanemaInstance = axios.create({
  baseURL: 'https://kanema.staticcomputersinc.com',
  timeout: 60000,
});

// Add a request interceptor
// In kanemaInstance.ts
kanemaInstance.interceptors.request.use(
  (config) => {
    // Skip adding auth header for refresh token endpoint
    if (config.url?.includes('/auth/refresh')) {
      return config;
    }

    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle 401 responses
kanemaInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Don't retry if it's not a 401 or we've already retried
    if (error.response?.status !== 401 || originalRequest._retry) {
      return Promise.reject(error);
    }

    // Skip refresh for login/refresh endpoints to prevent loops
    if (originalRequest.url?.includes('/auth/login') ||
      originalRequest.url?.includes('/auth/refresh')) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      console.log('Attempting to refresh token...');
      const tokens = await refreshAccessToken();

      if (tokens) {
        originalRequest.headers.Authorization = `Bearer ${tokens.accessToken}`;
        return kanemaInstance(originalRequest);
      }

      // If refresh failed, redirect to login
      window.location.href = '/login';
      return Promise.reject(new Error('Session expired. Please login again.'));

    } catch (refreshError) {
      window.location.href = '/login';
      return Promise.reject(refreshError);
    }
  }
);

export default kanemaInstance;